export const extractFileName = (disposition:any) => {
    if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) { 
          return matches[1].replace(/['"]/g, '');
        }
    }
    return "untitled"
}

export const validateDocumentId = (documentId : string) => {
    if (documentId === null || documentId === ""){
        return "Document Id is required";
    } else if (documentId.length !== 5 || !/^[a-zA-Z0-9]{5}$/.test(documentId)){
        return "Invalid document Id format";
    } else {
        return "";
    }
}